import type { PolicyInScope } from "../state/renewal-summary-port";

/**
 * AC-10/AC-22/AC-23's shared "policy line" (TG-4, ADR-20261027-81ff -- supersedes
 * ADR-20261016-bt2h's single-policy rule): always a count of policies,
 * singular for one ("1 policy to renew"), plural otherwise ("12 policies
 * to renew"). Owner/UX/tech-arch decision, fix/m1-portal-design-fixes:
 * the line descriptions + policy number rendering for exactly one policy
 * was dropped in favour of the same count shape at every policy total, so
 * screens 2, 7 and 8 never show two different line shapes depending on
 * how many policies happen to be in scope. Shared by those three screens
 * so the one rule lives in one place.
 */
export function formatPolicyLine(policiesInScope: readonly PolicyInScope[]): string {
  const count = policiesInScope.length;
  return `${count} ${count === 1 ? "policy" : "policies"} to renew`;
}
